"use strict";

class ExternalRegisterCtrl {

	/**
	 * [constructor description]
	 * @param  {[type]} $http [description]
	 * @return {[type]}       [description]
	 */
	constructor ( $http ) {

		let csrftoken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

		this.$http = $http;

		// Defaults
		this.formdata = {
			_token: csrftoken,
			firstname: window.first_name
		};

		this.status = {
			error: false,
			errorMessages: [],
			sending: false
		};
	}

	/**
	 * [submit description]
	 * @param  {Boolean} isValid [description]
	 * @return {[type]}          [description]
	 */
	submit ( isValid ) {

		if (!isValid) {

			return;
		}

		this.status.sending = true;
		this.status.error = false;
		this.status.errorMessages.length = 0;

		this.$http.post('/auth/registerexternal', this.formdata)
			.then(() => {

				// Login successfull!
				this.status.sending = false;
				window.location.reload();
			})
			.catch((response) => {

				// Extract Laravel errors
				Object.getOwnPropertyNames(response.data).forEach(( fieldName ) => {

                    response.data[fieldName].forEach(( message ) => {

						this.status.errorMessages.push(message);
					});
				});

				this.status.error = true;
				this.status.sending = false;
			});
	}
}

ExternalRegisterCtrl.$inject = ['$http'];

module.exports = ExternalRegisterCtrl;

